<template>
<div class="page_shopCenter page_agent myIndex page_park">
    <div class="userInfo">
        <div class="user">
            <div class="user_top">
                <div class="user_left" v-if="info">
                    <div class="thumb">
                        <van-image class="thumb" :src="info.thumb? ( $publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" fit="cover" :show-loading="false" :show-error="false" />
                    </div>
                    <div class="user_name slh_s">{{ info.nickname }}</div>
                </div>
                <div class="user_right" v-if="info">余额:￥{{ info.useraccount.park_money ? info.useraccount.park_money : 0}}</div>
            </div>
        </div>
    </div>
    <!-- 订单 -->
    <div class="con">
        <div class="order" :name="ordertab">
            <div class="top">
                <div class="tabs">
                    <span class="tab active" name="a" @click="changeTab('a')">商城订单</span>
                    <span class="tab" name="b" @click="changeTab('b')">云订单</span>
                </div>
                <span class="more" @click="orderList(0)">全部订单</span>
            </div>
            <div class="nr">
                <div class="txt active" name="a">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <!-- <div class="num" v-if="token && unpay_num!=0">{{unpay_num}}</div> -->
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
                            <!-- <div class="num" v-if="token && unship_num!=0">{{unship_num}}</div> -->
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
                            <!-- <div class="num" v-if="token && unreceipt_num!=0">{{ unreceipt_num }}</div> -->
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                            <!-- <div class="num">12</div> -->
                        </li>
                    </ul>
                </div>
                <div class="txt" name="b">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <!-- <div class="num" v-if="token && unpay_num!=0">{{unpay_num}}</div> -->
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
                            <!-- <div class="num" v-if="token && unship_num!=0">{{unship_num}}</div> -->
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
                            <!-- <div class="num" v-if="token && unreceipt_num!=0">{{ unreceipt_num }}</div> -->
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- 平台服务 -->
    <ul class="agent_list">
        <li class="item" @click="goServePage()">
            <div class="item_l">
                <img :src="publicPath+'statics/images/icon_income.png'" alt="" class="icon">
                <span class="">收入明细</span>
            </div>
        </li>
        <li class="item" @click="goWithdraw">
            <div class="item_l">
                <img :src="publicPath+'statics/images/icon_tixian.png'" alt="" class="icon">
                <span class="">提现</span>
            </div>
        </li>
        <!-- 提现记录比较复杂,前端暂不加 -->
        <!-- <li class="item" @click="goPage('agent-withdrawList')">
            <div class="item_l tixianlist">
                <img :src="publicPath+'statics/images/icon_tixianlist.png'" alt="" class="icon">
                <span class="">提现明细</span>
            </div>
        </li> -->
        <li class="item" @click="gotradesman()">
            <div class="item_l tixianlist">
                <img :src="publicPath+'statics/images/icon_member.png'" alt="" class="icon icon_member">
                <span class="">匠人列表</span>
            </div>
        </li>
        <li class="item" @click="goagent()">
            <div class="item_l tixianlist">
                <img :src="publicPath+'statics/images/icon_member.png'" alt="" class="icon icon_member">
                <span class="">一级代理商</span>
            </div>
        </li>
        <li class="item" @click="gosecagent()">
            <div class="item_l tixianlist">
                <img :src="publicPath+'statics/images/icon_member.png'" alt="" class="icon icon_member">
                <span class="">二级代理商</span>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            info: null, // 用户信息
            token: null,
            ordertab: 'a',
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "园区"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function () {

    },
    methods: {
        getData() {
            var that = this
            var params = {
                token: this.token
            }
            that.$api.park.parkInfo(params).then(res => {
                if (res.code == 200) {
                    that.info = res.result.info
                }
            })

        },
        gotradesman() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/' + 'my/park/tradesman'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: 'my-park-tradesman'
                })
            }
        },
        goagent() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/' + 'my/park/agent'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: 'my-park-agent'
                })
            }
        },
        gosecagent() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/' + 'my/park/secagent'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: 'my-park-secagent'
                })
            }
        },
        goServePage(){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/' + 'my/park/income'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: 'my-park-income'
                })
            }
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
        },
        // 提现
        goWithdraw() {
            this.$router.push({
                path: '/my/park/withdraw'
            })
        },
        // 订单切换
        changeTab: function (str) {
            this.ordertab = str
            $('.order .tab').removeClass('active')
            $('.order .txt').removeClass('active')
            $('.order .tab[name=' + str + ']').addClass('active')
            $('.order .txt[name=' + str + ']').addClass('active')
            if (str == 'a') {
                this.is_cloud = 0
            } else if (str == 'b') {
                this.is_cloud = 1
            }
        },
        // 查看订单
        orderList(status) {
            if (this.isClient) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/my/park/order?status=' + status + '&sorce=' + (this.ordertab == 'a' ? '0' : '1') + '&uuid=' + this.info.uuid + '&is_platprice=0'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/my/park/order',
                    query: {
                        status: status,
                        sorce: this.ordertab == 'a' ? '0' : '1',
                        // is_platprice: '0'
                    }
                })
            }
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
